import {hideLoadingFunction, showLoading} from 'Core/helpers/loading';
import {ioJsonAction} from 'Core/store/actions/io';
import * as dataMap from 'DataMaps/conditions/condition';
import {getArray, getString} from 'Core/helpers/data';
import {ConditionListFieldItemDataObject} from 'Core/components/advanced/ConditionList/ListItem';
import * as typeDataMap from 'DataMaps/conditions/type';
import {ltrimString} from 'Core/helpers/string';
import {translate} from 'Core/i18n';

/**
 *
 * @param {function} [abortCallback=(abortController)=>{}] - Callback function that will receive AbortController as an
 * argument.
 * @param {string} [clientId] - DB ID of the client (used by super admin).
 * @return {function(*): Promise<ConditionListFieldItemDataObject[]>}
 */
export const fetchCustomersSegmentColumnsAction = (abortCallback, clientId) => dispatch => {
	return ioJsonAction(
		abortCallback,
		'defaultAuthorizedApi',
		'campaign/fetch-customer-columns',
		{clientId},
	)(dispatch)
		.then(res => getArray(res, 'data').map(i => new ConditionListFieldItemDataObject(
			(
				getString(i, 'customerColumnName').startsWith('Custom Field:') ?
					ltrimString(getString(i, 'customerColumnName'), 'Custom Field:') :
					translate(getString(i, 'customerColumnName'), 'constants.customerFields')
			),
			getString(i, 'customerColumnName'),
			i,
			typeDataMap.input(getString(i, 'type'), getString(i, 'customerColumnName'))
		)));
}

/**
 * Add recipients from customers segment
 *
 * @param {function} [abortCallback=(abortController)=>{}] - Callback function that will receive AbortController as an
 * argument.
 * @param {ConditionListItemDataObject[]} segmentConditions - Segment conditions.
 * @param {string} messageDefinitionId - DB ID of the messaged definition.
 * @param {string} [loadingOverlaySelector] - Selector for the loading overlay.
 * @param {string} [clientId] - DB ID of the client (used by super admin).
 * @return {function(*): *}
 */
export const submitCustomersSegmentAction = (
	abortCallback, segmentConditions, messageDefinitionId, loadingOverlaySelector, clientId,
) => dispatch => {
	const loading = (loadingOverlaySelector ? showLoading(loadingOverlaySelector) : undefined);
	return ioJsonAction(
		abortCallback,
		'defaultAuthorizedApi',
		'campaign/add-customer-messages-by-customer-segment',
		{
			clientId, 
			conditions: getArray(segmentConditions).map((c, idx) => ({...dataMap.output(c), ordinal: idx + 1})),
			messageDefinitionId
		},
		hideLoadingFunction(loading),
	)(dispatch);
};